import React from 'react';
import { ModalCardProps } from '../types';
import { Button, ButtonVariants } from '../../Atoms/Button';
import { handleTrack } from '../../../utils/tracker';

const ModalCard: React.FC<ModalCardProps> = ({ card }) => {
  return (
    <a
      href={card.buttonUrl}
      onClick={() =>
        handleTrack({
          label: 'navbar_button_new_Get Started_itr_' + card.title,
        })
      }
      className="relative flex cursor-pointer flex-col mb-2 w-1/2 rounded-2xl sm:w-full sm:mb-3 xl:mb-4 h-[445px] md:h-[360px] sm:h-auto sm:max-w-[500px] bg-white"
      data-label={card.title}
    >
      <div className="w-full h-full">
        <div className="flex w-full h-full">
          <div className="w-4/12">
            <div className="absolute left-0 top-0 bottom-0 w-auto h-full">
              <img
                src={card.image}
                alt="login pic"
                className="w-auto h-full object-cover rounded-l-2xl"
              />
            </div>
          </div>
          <div className="w-8/12 h-full rounded-r-2xl relative right-0 top-0 bottom-0 z-10 p-10 lg:p-6 md:p-6 sm:p-6 bg-white">
            <div className="sm:block">
              <p className="text-3xl font-bold pb-4 leading-8 md:text-2xl sm:text-xl text-font-500">
                {card.title}
              </p>
              <p className="text-xl font-semibold pb-4 mx-auto md:text-base sm:mx-0 sm:text-base text-font-500">
                {card.subTitle}
              </p>
            </div>
            <ul className="w-full">
              {card.lists.map((listItem, listIndex) => (
                <li
                  key={listIndex}
                  className="flex items-center pr-2 text-xl lg:text-base md:text-base sm:text-base leading-8 md:leading-6 sm:leading-6 text-font-500"
                >
                  <img
                    src={card.listIcon}
                    alt="check"
                    className="w-4 h-4 mr-2 flex-shrink-0"
                  />
                  <span dangerouslySetInnerHTML={{ __html: listItem }} />
                </li>
              ))}
            </ul>
            <div className="absolute bottom-10 left-6 right-6 self-center w-10/12 sm:w-full sm:static sm:mt-6 sm:mb-0 md:bottom-6">
              <Button
                variant={ButtonVariants.bluefilled}
                rounded="sm"
                className="w-full"
              >
                {card.buttonText}
              </Button>
            </div>
          </div>
        </div>
      </div>
    </a>
  );
};

export default ModalCard;
